import { __decorate, __metadata, __param } from "tslib";
import { BootstrapGridBreakpoints } from '@gn-audio/ui/constants/bootstrap-grid-breakpoints';
import { Directive, Inject, Input } from 'angular-ts-decorators';
import { element } from 'angular';
var defaultAnimateTiming = 400;
import expandTemplate from './product-read-more.template.expand.html';
import template from './product-read-more.template.html';
var ProductReadMoreDirective = (function () {
    function ProductReadMoreDirective($scope, $element, $compile, $timeout) {
        this.$scope = $scope;
        this.$element = $element;
        this.$compile = $compile;
        this.$timeout = $timeout;
    }
    ProductReadMoreDirective.prototype.ngOnInit = function () {
        var _this = this;
        var mode = window.innerWidth < BootstrapGridBreakpoints.Medium ? 'mobile' : 'desktop';
        var $parent = this.$element.parent();
        var $close = $parent.find('.product-read-more__close');
        var $label = this.$element.find('.product-read-more__label');
        var $slick = $parent.find('slick');
        var $labels = $parent.find('product-item-labels');
        var $calloutMessage = $parent.find('callout-message');
        var $features = $parent.find('.product-item-features__container');
        var $readMore = this.$element.find('.product-read-more__label--collapsed');
        var $readLess = this.$element.find('.product-read-more__label--expanded');
        var clickHandler = function (eventObject) {
            var $bullets = _this.$element.find('product-bullets');
            var compiled = $bullets.length > 0;
            if (compiled) {
                $close.fadeToggle(defaultAnimateTiming);
                $features.slideToggle(defaultAnimateTiming);
                $bullets.slideToggle(defaultAnimateTiming);
                $readMore.toggle();
                $readLess.toggle();
                $labels.toggle();
                $calloutMessage.toggle();
                if (mode === 'desktop') {
                    $slick.slideToggle(defaultAnimateTiming, function () { $slick.slick('setPosition'); });
                }
            }
            else {
                _this.$scope.productId = _this.productId;
                _this.$scope.productType = _this.productType;
                _this.$scope.emptyText = _this.emptyText;
                var compiledElement = _this.$compile(expandTemplate)(_this.$scope);
                _this.$element.prepend(compiledElement);
            }
            eventObject.preventDefault();
        };
        var resizeHandler = function () {
            var prevMode = mode;
            mode = window.innerWidth < BootstrapGridBreakpoints.Medium ? 'mobile' : 'desktop';
            if (prevMode !== mode) {
                cleanUp();
            }
        };
        var cleanUp = function () {
            var $bullets = _this.$element.find('product-bullets');
            $readMore.show();
            $readLess.hide();
            $labels.show();
            $calloutMessage.fadeIn();
            $close.fadeOut(defaultAnimateTiming);
            $bullets.slideUp(defaultAnimateTiming);
            $features.slideDown(defaultAnimateTiming);
            $slick.slideDown(defaultAnimateTiming, function () { $slick.slick('setPosition'); });
        };
        this.$scope.onBulletsLoaded = function () {
            _this.$timeout(function () {
                var $bullets = _this.$element.find('product-bullets');
                $readMore.hide();
                $readLess.show();
                $labels.hide();
                $calloutMessage.hide();
                $features.slideUp(defaultAnimateTiming);
                $bullets.slideDown(defaultAnimateTiming);
                if (mode === 'desktop') {
                    $slick.slideUp(defaultAnimateTiming);
                    $close.fadeIn(defaultAnimateTiming);
                }
            }, 0, false);
        };
        $label.on('click', clickHandler);
        $close.on('click', clickHandler);
        element(window).on('resize', resizeHandler);
        resizeHandler();
        this.$scope.$on('$destroy', function () {
            $label.off('click', clickHandler);
            $close.off('click', clickHandler);
            element(window).off('resize', resizeHandler);
        });
    };
    ProductReadMoreDirective.$inject = ['$scope', '$element', '$compile', '$timeout'];
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ProductReadMoreDirective.prototype, "productId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ProductReadMoreDirective.prototype, "productType", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ProductReadMoreDirective.prototype, "emptyText", void 0);
    ProductReadMoreDirective = __decorate([
        Directive({
            restrict: 'E',
            selector: 'productReadMore',
            template: template,
        }),
        __param(0, Inject('$scope')),
        __param(1, Inject('$element')),
        __param(2, Inject('$compile')),
        __param(3, Inject('$timeout')),
        __metadata("design:paramtypes", [Object, Object, Function, Function])
    ], ProductReadMoreDirective);
    return ProductReadMoreDirective;
}());
export { ProductReadMoreDirective };
